import "lazysizes";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";

/**********************************************
Theme
**********************************************/

class Theme {
  constructor() {
    // Bindings
    this.replaceRecursively = this.replaceRecursively.bind(this);
    this.onClickModalBtn = this.onClickModalBtn.bind(this);

    // Setup: Format internal / external links from Shopify's rich text fields...
    let all_links = document.querySelectorAll('a');

    all_links.forEach((el) => {
      let origin = window.location.origin,
          href = el.getAttribute('href');

      // Starts with mailto or http, it's external...
      if (href.match(/^mailto\:/) || href.match(/^http/)) {
        // But wait, is it also not the same origin??
        if (!href.includes(origin)) {
          el.target = '_blank';
          el.rel = 'noreferrer noopener';
          el.classList.add('--external');
        } else {
          if (el.hasAttribute('target')) {
            el.removeAttribute('target');
          }
          el.target = '_self';
        }
      } else {
        if (el.hasAttribute('target')) {
          el.removeAttribute('target');
        }
        el.target = '_self';
      }
    });

    // Replace for aer1 to aer(subscript)1
    this.replaceRecursively(document.body, /aer1/gi, 'Aer₁');

    this._modal = document.getElementById('modal-wrapper');
    this._modal_btn = document.querySelectorAll('.open-modal-btn');

    if (this._modal_btn.length > 0) {
      this._modal_btn.forEach((el) => {
        el.addEventListener('click', this.onClickModalBtn);
      })
    }
  }

  // Replace
  replaceRecursively(element, from, to) {
    if (element.childNodes.length) {
      element.childNodes.forEach((child) => {
        this.replaceRecursively(child, from, to, parent);
      });
    } else {
      const cont = element.textContent;
      if (cont) {
        if (cont.match(from)) {
          element.textContent = cont.replace(from, to);
        }
      }
    }
  }

  onClickModalBtn(e) {
    let id = `open_${e.currentTarget.getAttribute('data-mid')}`;

    if (id) {
      id = id.replace('-', '_');
      this._modal.dataset[id] = true;
    }
  }
}

new Theme();

/**********************************************
Sections
**********************************************/

// import HomeHero from "@/scripts/sections/home-hero";
// import NewsletterCta from "@/scripts/sections/newsletter-cta";
// import ArticleCarousel from "@/scripts/sections/article-carousel";
// import MediaCarousel from "@/scripts/sections/media-carousel";
// import RichtextBlock from "@/scripts/sections/richtext-block";
// import StartKitHero from "@/scripts/sections/starter-kit-hero";
// import CapConfigurator from "@/scripts/sections/cap-configurator";
// import StickyScrollSlideshow from "@/scripts/sections/sticky-scroll-slideshow";
// import AccountForms from "@/scripts/sections/account-forms";
// import AccountNav from "@/scripts/sections/account-nav";
// import AccountDashboard from "@/scripts/sections/account-dashboard";
// import AccountProfile from "@/scripts/sections/account-profile";
// import AccountOrders from "@/scripts/sections/account-orders";
// import RodHero from "@/scripts/sections/rod-hero";
// import BlogFeaturedPostsCarousel from "@/scripts/sections/blog-featured-posts-carousel";
// import ArticlesGrid from "@/scripts/sections/articles-grid";
// import SubnavJumpTo from "@/scripts/sections/subnav-jump-to";
// import SubnavCaps from "@/scripts/sections/subnav-caps";
// customElements.define("header-component", HeaderComponent);
// customElements.define("home-hero", HomeHero);
// customElements.define("newsletter-cta", NewsletterCta);
// customElements.define("article-carousel", ArticleCarousel);
// customElements.define("media-carousel", MediaCarousel);
// customElements.define("richtext-block", RichtextBlock);
// customElements.define("starter-kit-hero", StartKitHero);
// customElements.define("cap-configurator", CapConfigurator);
// customElements.define("sticky-scroll-slideshow", StickyScrollSlideshow);
// customElements.define("account-forms", AccountForms);
// customElements.define("account-nav", AccountNav);
// customElements.define("account-dashboard", AccountDashboard);
// customElements.define("account-profile", AccountProfile);
// customElements.define("account-orders", AccountOrders);
// customElements.define("rod-hero", RodHero);
// customElements.define("blog-featured-posts-carousel", BlogFeaturedPostsCarousel);
// customElements.define("articles-grid", ArticlesGrid);
// customElements.define("subnav-jump-to", SubnavJumpTo);
// customElements.define("subnav-caps", SubnavCaps);
import HeaderComponent from "@/scripts/sections/header";
import CartDrawer from "@/scripts/sections/cart-drawer";
import CartRecs from "@/scripts/sections/cart-recs";
// import GiftCardBuying from "@/scripts/sections/gift-card-buying";
import ShopAll from "@/scripts/sections/shop-all";
import HowItWorksHero from "@/scripts/sections/how-it-works-hero";
import CustomerPortal from "@/scripts/sections/customer-portal";
import CustomerLogin from "@/scripts/sections/customer-login";
customElements.define("header-component", HeaderComponent);
customElements.define("cart-drawer", CartDrawer);
customElements.define("cart-recs", CartRecs);
// customElements.define("gift-card-buying", GiftCardBuying);
customElements.define("shop-all", ShopAll);
customElements.define("how-it-works-hero", HowItWorksHero);
customElements.define("customer-portal", CustomerPortal);
customElements.define("customer-login", CustomerLogin);

// Start page...
import StartPage from "@/scripts/sections/start-page";
import FaqCarousel from "@/scripts/snippets/faq-carousel";
customElements.define("start-page", StartPage);
customElements.define("faq-carousel", FaqCarousel);

// Capsule Exchange Flow
import CapsuleExchangeFlow from "@/scripts/sections/capsule-exchange-flow";
customElements.define("capsule-exchange-flow", CapsuleExchangeFlow);

/**********************************************
 Snippets
**********************************************/
// import GLBLoader from "@/scripts/snippets/glb-loader";
// import ResponsiveImage from "@/scripts/snippets/responsive-image";
// import YoutubePlayer from "@/scripts/snippets/youtube-player";
// import ToolTip from "@/scripts/snippets/tool-tip";
// import CartLineItem from "@/scripts/snippets/cart-line-item";
// import SuggestedProductsCarousel from "@/scripts/snippets/suggested-products-carousel";
// import Modal from "@/scripts/snippets/modal";
// customElements.define("glb-loader", GLBLoader);
// customElements.define("responsive-image", ResponsiveImage);
// customElements.define("youtube-player", YoutubePlayer);
// customElements.define("tool-tip", ToolTip);
// customElements.define("cart-line-item", CartLineItem);
// customElements.define("suggested-products-carousel", SuggestedProductsCarousel);
// customElements.define("modal-container", Modal);
import AccordionContainer from "@/scripts/snippets/accordion";
import AddToCartComponent from "@/scripts/snippets/add-to-cart";
import ComparisonChart from "@/scripts/snippets/comparison-chart";
import LifestyleCards from "@/scripts/snippets/lifestyle-cards";
import Marquee from "@/scripts/snippets/marquee";
import ModalComponent from "@/scripts/snippets/modal-component";
import MenuCarousel from "@/scripts/snippets/menu-carousel";
import ProductHeroCarousel from "@/scripts/snippets/product-hero-carousel";
import ProductHeroColumns from "@/scripts/snippets/product-hero-columns";
import ProductTabs from "@/scripts/snippets/product-tabs";
import ProductsCarousel from "@/scripts/snippets/products-carousel";
import ResponsiveImage from "@/scripts/snippets/responsive-image";
import SubscribeComponent from "@/scripts/snippets/subscribe-component";
import VideoChart from "@/scripts/snippets/video-chart";
import VideoPlayer from "@/scripts/snippets/video-player";
customElements.define("accordion-container", AccordionContainer);
customElements.define("add-to-cart-component", AddToCartComponent);
customElements.define("comparison-chart", ComparisonChart);
customElements.define("lifestyle-cards", LifestyleCards);
customElements.define("marquee-container", Marquee);
customElements.define("modal-component", ModalComponent);
customElements.define("menu-carousel", MenuCarousel);
customElements.define("product-hero-carousel", ProductHeroCarousel);
customElements.define("product-hero-columns", ProductHeroColumns);
customElements.define("product-tabs", ProductTabs);
customElements.define("products-carousel", ProductsCarousel);
customElements.define("responsive-image", ResponsiveImage);
customElements.define("subscribe-component", SubscribeComponent);
customElements.define("video-chart", VideoChart);
customElements.define("video-player", VideoPlayer);

// 1st Exchange Flow
import FirstExchangeFlow from "@/scripts/snippets/first-exchange-flow";
customElements.define("first-exchange-flow", FirstExchangeFlow);

/**********************************************
Templates
**********************************************/
// import CartTemplate from "@/scripts/templates/cart";
// customElements.define("cart-template", CartTemplate);
